var _circle, _circle2, _path, _g, _path2, _path3, _g2, _path4, _g3, _ellipse, _ellipse2, _g4, _g5, _ellipse3, _ellipse4, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 232,
    viewBox: "0 0 264 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.978,
    cy: 143.978,
    r: 87.9783,
    fill: "url(#paint0_linear_7657_7360)",
    fillOpacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.978,
    cy: 143.978,
    r: 86.9783,
    stroke: "url(#paint1_linear_7657_7360)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7657_7360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 172,
    width: 54,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1035 172.609L145.661 185.888L141.565 201.177L92.0068 187.898L96.1035 172.609Z",
    fill: "#004E9A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7657_7360)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.991,
    cy: 167.65,
    r: 27.2904,
    transform: "rotate(15 123.991 167.65)",
    fill: "#004E9A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8649 151.958L66.6753 160.13L176.862 189.654L179.052 181.482C170.608 179.22 165.597 170.541 167.859 162.097L174.91 135.785C180.839 113.656 167.707 90.9101 145.578 84.9807C123.449 79.0512 100.703 92.1836 94.7737 114.312L87.5823 141.151C85.3977 149.304 77.0177 154.142 68.8649 151.958Z",
    fill: "#B2CAE1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7657_7360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 67,
    width: 36,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.845 83.7429L131.234 83.681L132.238 67.2807L150.201 69.8336L166.77 76.5336L158.649 91.0268L152.289 87.3451L145.261 84.0494L138.845 83.7429Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7657_7360)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.053,
    cy: 84.2649,
    r: 10.6433,
    transform: "rotate(15 146.053 84.2649)",
    stroke: "#263238",
    strokeWidth: 6.5497
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7657_7360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 83,
    width: 113,
    height: 108
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5935 152.956L66.4039 161.128L176.591 190.652L178.78 182.48C170.337 180.218 165.326 171.538 167.588 163.095L174.908 135.777C180.837 113.648 167.705 90.9023 145.576 84.9729C123.447 79.0434 100.701 92.1757 94.7718 114.305L87.3108 142.149C85.1263 150.302 76.7463 155.14 68.5935 152.956Z",
    fill: "url(#paint2_linear_7657_7360)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7657_7360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.498 154.5L177.998 184.497L176.998 189.997L66.498 160.5L67.498 154.5Z",
    fill: "#8EB1D3"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.08929,
    cy: 6.09314,
    rx: 6.08929,
    ry: 6.09314,
    transform: "matrix(-1 0 0 1 153.57 0)",
    fill: "#004E9A",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.42857,
    cy: 4.43137,
    rx: 4.42857,
    ry: 4.43137,
    transform: "matrix(-1 0 0 1 42.8574 85.3047)",
    fill: "#004E9A",
    fillOpacity: 0.15
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7657_7360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.534 42.6556C210.534 45.7449 213.037 48.2488 216.124 48.2488C219.21 48.2488 221.713 45.7449 221.713 42.6556C221.713 39.5663 219.21 37.0625 216.124 37.0625C213.037 37.0625 210.534 39.5663 210.534 42.6556Z",
    stroke: "#004E9A",
    strokeOpacity: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_7657_7360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.821 161.744C254.821 163.915 256.58 165.675 258.749 165.675C260.919 165.675 262.678 163.915 262.678 161.744C262.678 159.572 260.919 157.812 258.749 157.812C256.58 157.812 254.821 159.572 254.821 161.744Z",
    stroke: "#004E9A",
    strokeOpacity: 0.3
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76786,
    cy: 2.76961,
    rx: 2.76786,
    ry: 2.76961,
    transform: "matrix(-1 0 0 1 109.285 22.1562)",
    fill: "#004E9A",
    fillOpacity: 0.15
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76786,
    cy: 2.76961,
    rx: 2.76786,
    ry: 2.76961,
    transform: "matrix(-1 0 0 1 163.535 29.9062)",
    fill: "#004E9A",
    fillOpacity: 0.15
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_7657_7360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.1063 32.1267L61.6777 27.6953M66.1063 32.1267L70.5349 27.6953M66.1063 32.1267L61.6777 36.5581M66.1063 32.1267L70.5349 36.5581",
    stroke: "#004E9A",
    strokeOpacity: 0.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_7657_7360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.071 94.1657L226.643 89.7344M231.071 94.1657L235.5 89.7344M231.071 94.1657L226.643 98.5971M231.071 94.1657L235.5 98.5971",
    stroke: "#004E9A",
    strokeOpacity: 0.3
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_7657_7360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.713 52.6183L185.677 42.0938",
    stroke: "#004E9A",
    strokeOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7657_7360",
    x: 210.035,
    y: 36.5625,
    width: 12.1777,
    height: 16.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7657_7360"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7657_7360"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_7657_7360",
    x: 254.32,
    y: 157.312,
    width: 8.85742,
    height: 12.8594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7657_7360"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7657_7360"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_7657_7360",
    x: 61.3242,
    y: 27.3438,
    width: 9.56445,
    height: 13.5703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7657_7360"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7657_7360"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_7657_7360",
    x: 226.289,
    y: 89.3828,
    width: 9.56445,
    height: 13.5703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7657_7360"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7657_7360"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_7657_7360",
    x: 175.35,
    y: 41.75,
    width: 10.6914,
    height: 15.2109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_7657_7360"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.482353 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7657_7360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7657_7360",
    x1: 133.978,
    y1: 56,
    x2: 133.978,
    y2: 231.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7657_7360",
    x1: 133.978,
    y1: 56,
    x2: 133.978,
    y2: 231.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7657_7360",
    x1: 145.84,
    y1: 85.0435,
    x2: 122.036,
    y2: 173.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.c0c44fe06be916f75927ab5544952542.svg";
export { ForwardRef as ReactComponent };